import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import SimpleBar from 'simplebar-react';
import { getReportUniqueBusinessKey } from '../../../../../../../../utils/common';
import { getReportResourcePreviewUrl } from '../../../../../../../../utils/reportResourceUtil';
import type { DescriptorDiff, ReportWithDiffType } from '../../types';
import DescriptorCell from './components/descriptorCell';
import type { ColumnLabels, GetTooltipContent } from './types';

export function ScrollTable({ children, className }: { children: ReactNode; className: string }) {
    return (
        <SimpleBar autoHide={false} className="branch-comparison-details__scroll-wrapper">
            <div className="branch-comparison-details__inner">
                <table className={`branch-comparison-details__table ${className}`}>{children}</table>
            </div>
        </SimpleBar>
    );
}

export function ModelContent({ diffs, columnLabels, getTooltipContent }: {
    diffs: DescriptorDiff[];
    columnLabels: ColumnLabels;
    getTooltipContent: GetTooltipContent;
}) {
    if (diffs.length === 0) {
        return null;
    }

    return (
        <ScrollTable className="branch-comparison-details__table--model">
            <thead><tr><th className="branch-comparison-details__column--descriptor">Descriptor</th></tr></thead>
            <tbody>
                {diffs.map((diff) => (
                    <tr key={diff.descriptorId} className={`branch-comparison-details__row--${diff.diffType.toLowerCase()}`}>
                        <DescriptorCell
                            label={diff.label}
                            tooltipContent={getTooltipContent(diff.descriptorId, diff.label)}
                            descriptorId={diff.descriptorId}
                            modelDiff={diff}
                            columnLabels={columnLabels}
                        />
                    </tr>
                ))}
            </tbody>
        </ScrollTable>
    );
}

export function ReportHeader({ report, label, companyId }: {
    report: ReportWithDiffType;
    label: string;
    companyId?: string;
}) {
    const reportKey = getReportUniqueBusinessKey(report);
    return (
        <th key={reportKey} className={`branch-comparison-details__cell--${report.diffType.toLowerCase()}`}>
            {companyId ? (
                <Link to={getReportResourcePreviewUrl(reportKey, companyId)} target="_blank" rel="noopener noreferrer">
                    {label}
                </Link>
            ) : label}
        </th>
    );
}
